import React, { FunctionComponent, useState } from "react";
import { FooterProps } from "./types/Footer.types";
import "./Footer.scss";

import FooterInfo from "./FooterInfo/FooterInfo";
import FooterNav from "./FooterNav/FooterNav";
import FooterSocial from "./FooterSocial/FooterSocial";
import { Waypoint } from "react-waypoint";
import withErrorCatch from "../../helper/withErrorCatch";
import FooterAIButton from "./FooterAIButton";

const FooterWrapper = (props: FooterProps) => {
  const [shouldRender, setShouldRender] = useState(false);

  return (
    <>
      <Waypoint
        onEnter={({ currentPosition }) => {
          if (currentPosition === "inside") setShouldRender(true);
        }}
      />

      {shouldRender && <Footer {...props} />}
    </>
  );
};

const Footer: FunctionComponent<FooterProps> = (props) => {
  return (
    <footer className="Footer">
      {props?.fields?.enableAiAssistant?.value && (
        <FooterAIButton link={props?.fields?.link} icon={props?.fields?.icon} />
      )}
      <div className="Footer__section">
        <FooterInfo logoImage={props.fields.logo} info={props.fields?.text} />
      </div>

      <div className="Footer__section_with_margin">
        <FooterNav usefulLinks={props.fields?.navigation || []} />
      </div>

      <div className="Footer__section">
        <FooterSocial socialList={props.fields?.socialLinks || []} />
      </div>
    </footer>
  );
};

export default withErrorCatch(Footer);
